<template>
    <b-alert
        v-if="canSeeBlock"
        :button-title="reportButton"
        :has-content="reportHasContent"
        :has-header-button="true"
        :loading="reportLoading"
        :message="reportTitle"
        type="error"
        @emitAction="$root.goTo($root.route('quality-control.index'))"
    >
        <div v-if="reportListsItemsTitle.length" class="list">
            <ul>
                <li v-for="(titles, index) in reportListsItemsTitle" :key="index">
                    {{ titles }}
                    <span v-if="reportListsItems[index]">&nbsp;-&nbsp;&nbsp;{{ reportListsItems[index] }}</span>
                </li>
            </ul>
        </div>
    </b-alert>
</template>
<script>
export default {
    name: 'ReportBlockedComponent',
    data() {
        return {
            reportListsItemsTitle: [],
            reportListsItems: {},
        };
    },
    computed: {
        report() {
            return this.$store.state.qualityControl.blocked_device;
        },
        reportList() {
            return this.report.list;
        },
        reportLoading() {
            return this.report.loading;
        },
        reportTitle() {
            return this.report.title;
        },
        reportButton() {
            return this.report.buttonText;
        },
        reportHasContent() {
            return this.report.hasContent;
        },
        reportHasDeviceWithoutOperator() {
            return this.report.hasDeviceWithoutOperator;
        },
        canSeeBlock() {
            return (
                this.reportHasContent &&
                (this.$store.state.user.profile.role === 'admin-dms-staff' ||
                    this.$store.state.user.profile.role === 'hcp-trained' ||
                    this.$store.state.user.profile.role === 'hcp-analyser-dispenser')
            );
        },
    },
    watch: {
        reportList(items) {
            if (items) {
                this.reportListsItemsTitle = Object.keys(this.report.list).map((key) => `(${key})`);
                Object.values(this.report.list).forEach((value, index) => {
                    this.reportListsItems[index] = value.map((val) => val.device_name).join(`,  `);
                });
            }
        },
    },
    created() {
        if (!this.can('api.v1.quality-control.blocked-devices')) {
            return;
        }
        this.$store
            .dispatch('qualityControl/fetchBlockedDeviceList')
            .then(() => {
                this.$store.dispatch(
                    'qualityControl/setBlockedDeviceTitle',
                    t('quality-control::title.blocked_for_patient_samples')
                );
                this.$store.dispatch(
                    'qualityControl/setBlockedDeviceButtonText',
                    t('quality-control::button.go_to_qc_module')
                );
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.error) {
                    this.$root.notify('error', error.response.data.error);
                }
            });
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
::v-deep .v-alert {
    top: 10px;
    padding: 0 20px;

    .header {
        align-items: center;
        display: flex;

        .alert-btn {
            height: 30px;
            border-color: #fff;
            right: 30px;
            padding: 0 20px !important;
        }
    }

    .v-alert__wrapper {
        &:before {
            top: 5px;
            position: relative;
        }
    }
}

.b-alert {
    padding: 0 16px;
}
</style>
